import { createContext } from 'react';

import type { ActionCardFormFactor } from '@littlebird/action-cards';

// The Feed offers compact and comfortable rows; a device that saved the retired "expanded" reads as compact
const FEED_DENSITIES = [
  'comfortable',
  'compact',
] as const satisfies readonly Exclude<ActionCardFormFactor, 'full'>[];

export type FeedDensity = (typeof FEED_DENSITIES)[number];

export const toFeedDensity = (value: unknown): FeedDensity =>
  FEED_DENSITIES.find((density) => density === value) ?? 'compact';

export const FeedDensityContext = createContext<FeedDensity>('compact');

// Compact rows hold one line each; comfortable rows add the card's reason and its own button.
export const isDenseFeed = (density: FeedDensity): boolean =>
  density !== 'comfortable';
